<script>
import { mapActions, mapState } from 'vuex';
import appConfig from "@/app.config";
import Loading from "@/components/Loading";
import Stat from "@/components/dashboard/stat";
import { summary } from "@/api/dashboard";

export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  computed: {
    ...mapState({
      config: state => state.auth.config,
      user: state => state.auth.user
    }),
  },
  methods: {
    ...mapActions({
    }),
  },
  components: {
    Loading,
    Stat,
  },
  data() {
    return {
      loading: true,
      balance: 0,
      stats: {
        withdrawals: {
          total: 0,
          successful: 0
        },
        deposits: {
          total: 0,
          successful: 0
        }
      },
      lastApproveds: []
    };
  },
  mounted() {
    this.loading = true;
    summary().then((response) => {
      const r = response.data.data;
      this.stats =r.stats;
      this.balance =r.balance;
      this.lastApproveds = r.lastApproveds
      this.loading = false;
    })
  }
};
</script>

<template>
  <div>
    <div v-if="user.role !== 'iban_control'" class="row">
      <div class="col" v-if="config.balanceSystem">
        <Stat icon="bx bx-money" title="Kasa Durumu" :value="balance | money" color="bg-balance"  class="balance" textColor="white" />
      </div>
      <div class="col">
        <Stat icon="bx bx-chevron-down" title="Onaylı Para Yatırma" :value="stats.deposits.successful | money" color="bg-success" />
      </div>
      <div class="col">
        <Stat icon="bx bx-chevron-up" title="Onaylı Para Çekme" :value="stats.withdrawals.successful | money" color="bg-warning" />
      </div>
    </div>
    <div class="row">
     <div class="col-12">
       <div class="card">
         <div class="card-body">
           <h4 class="card-title mb-4">Son Onaylanan İşlemler (son 24 saat)</h4>
           <b-card-text class="table-responsive">
             <table class="table table-centered table-nowrap table-hover table-striped">
               <thead>
               <tr>
                 <th>Site</th>
                 <th>Banka</th>
                 <th>Kullanıcı</th>
                 <th class="text-center">Miktar</th>
                 <th class="text-center">Tür</th>
                 <th class="text-right">Tarih</th>
               </tr>
               </thead>
               <tbody>
               <tr v-for="item in lastApproveds" :key="item._id">
                 <td><h5 class="font-size-14 mb-0">{{ item._site.name }}</h5></td>
                 <td>{{item._bank.name}}</td>
                 <td>
                   <p class="font-size-13 mb-0">{{item.params.name}}</p>
                   <p class="text-muted mb-0">{{ item.params.userId }}</p>
                 </td>
                 <td>
                   <template v-if="item.amount.approved && item.amount.approved !== item.amount.original">
                     <p class="font-size-13 mb-0"><del>{{item.amount.original | money}}</del></p>
                     <p class="font-size-13 mb-0">{{item.amount.approved | money}}</p>
                   </template>
                   <template v-else>
                     <p class="font-size-13 mb-0">{{item.amount.original | money}}</p>
                   </template>
                 </td>
                 <td class="text-center">
                   <span v-if="item.type === 'deposit'" class="badge badge-success badge-pill">Yatırım</span>
                   <span v-else class="badge badge-warning badge-pill">Çekim</span>
                 </td>
                 <td class="text-right">
                   <p class="font-size-13 mb-0">{{item.createdAt | formatDate}}</p>
                 </td>
               </tr>
               </tbody>
             </table>
           </b-card-text>
         </div>
       </div>
     </div>
    </div>
    <Loading v-if="loading" />
  </div>
</template>

<style lang="scss">
.card.balance {
  background: #34c38f;
  p {
    color :#1a6f50 !important;
    font-weight: 600;
  }
  .bg-balance {
    background-color: #3da981 !important;
  }
}
</style>
